var map = {
	"./bg-10.jpg": 2079,
	"./bg-9.jpg": 701,
	"./certificate.png": 1563,
	"./image.png": 7195,
	"./logo-1.png": 3027,
	"./logo-2.png": 9845,
	"./logo-3.png": 8144,
	"./logo-4.png": 3953,
	"./logo-5.png": 50,
	"./logo.png": 1516,
	"./logo_48.png": 1355,
	"./truck-1.png": 3499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5666;